/// <reference path="../../types/hookrouter.d.ts" />

import { RoutesDefinition, usePath, useRoutes } from 'hookrouter';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import '../scss/main.scss';
import { AppContext, Content, Location, Partner, Product, Purchase, User } from './AppContext';
import { ScreenWrapper } from './components/ScreenWrapper';
import { rs } from './i18n/rs';
import { en } from './i18n/en';
import { DynamicScreen } from './screens/DynamicScreen';
import { ErrorScreen } from './screens/Error';
import HomeScreen from './screens/Home';

const routes: RoutesDefinition = {
    '/': () => <HomeScreen />,
    '/partners': () => <DynamicScreen screen={() => import('./screens/Partners')} />,
    '/gifts': () => <DynamicScreen screen={() => import('./screens/Gifts')} />,
    '/gifts/:id': (params) => (
        <DynamicScreen params={params} screen={() => import('./screens/GiftDetails')} />
    ),
    '/profile': () => <DynamicScreen screen={() => import('./screens/Profile')} />,
    '/signin': () => <DynamicScreen screen={() => import('./screens/SignIn')} />,
    '/signup': () => <DynamicScreen screen={() => import('./screens/SignUp')} />,
    '/forgot-password': () => <DynamicScreen screen={() => import('./screens/ForgotPassword')} />,
    '/reset-password/:token': (params) => (
        <DynamicScreen params={params} screen={() => import('./screens/ResetPassword')} />
    ),
    '/game': () => <DynamicScreen screen={() => import('./screens/Game')} />,
    '/points': () => <DynamicScreen screen={() => import('./screens/Points')} />,
    '/help': () => <DynamicScreen screen={() => import('./screens/Help')} />,
    '/redeem': () => <DynamicScreen screen={() => import('./screens/Redeem')} />,
    '/locations': () => <DynamicScreen screen={() => import('./screens/Locations')} />,
    '/locations/map': () => <DynamicScreen screen={() => import('./screens/LocationsMap')} />,
    '/purchased': () => <DynamicScreen screen={() => import('./screens/Purchased')} />,
};

const App = () => {
    const page = useRoutes(routes);
    const path = usePath(false);

    const [user, setUser] = useState<User>({});
    const [locations, setLocations] = useState<Location[]>([]);
    const [gifts, setGifts] = useState<Product[]>([]);
    const [purchased, setPurchased] = useState<Purchase[]>([]);
    const [partners, setPartners] = useState<Partner[]>([]);
    const [content, setContent] = useState<Content>(en);
    const [activePartner, setActivePartner] = useState('h6f200mkkz3iqt17djh1u2o');

    if (page === null) {
        return <ErrorScreen error="Page not found." />;
    }

    if (path === '/' || path === '/signin' || path === '/signup' || path === '/forgot-password' || path.startsWith('/reset-password/')) {
        return (
            <AppContext.Provider
                value={{
                    user,
                    setUser,
                    locations,
                    setLocations,
                    partners,
                    setPartners,
                    purchased,
                    setPurchased,
                    gifts,
                    setGifts,
                    content,
                    setContent,
                    activePartner,
                    setActivePartner,
                }}
            >
                {page}
            </AppContext.Provider>
        );
    }

    return (
        <AppContext.Provider
            value={{
                user,
                setUser,
                locations,
                setLocations,
                partners,
                setPartners,
                purchased,
                setPurchased,
                gifts,
                setGifts,
                content,
                setContent,
                activePartner,
                setActivePartner,
            }}
        >
            <ScreenWrapper>{page}</ScreenWrapper>
        </AppContext.Provider>
    );
};

ReactDOM.render(<App />, document.getElementById('root'));
